let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1HTq6")).then(() => parcelRequire('4AOf5'));